(function() {
  'use strict';

  var checkoutPending = null;

  function getPreorderData() {
    var script = document.getElementById('custom-preorder-data');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function hasPreorderItems() {
    var data = getPreorderData();
    return data && data.items && data.items.length > 0;
  }

  function showModal(callback) {
    var overlay = document.getElementById('custom-preorder-overlay');
    if (!overlay) { if (callback) callback(); return; }

    checkoutPending = callback || null;
    overlay.classList.remove('hidden');
  }

  function hideModal() {
    var overlay = document.getElementById('custom-preorder-overlay');
    if (!overlay) return;
    overlay.classList.add('hidden');
    checkoutPending = null;
  }

  function confirmCheckout() {
    var overlay = document.getElementById('custom-preorder-overlay');
    if (overlay) {
      overlay.classList.add('hidden');
    }
    if (typeof checkoutPending === 'function') {
      var fn = checkoutPending;
      checkoutPending = null;
      fn();
    }
  }

  function interceptCheckoutSubmit(event) {
    if (!hasPreorderItems()) return;

    var submitter = event.submitter || event.target.querySelector('[name="checkout"]');
    if (!submitter || submitter.getAttribute('name') !== 'checkout') return;

    event.preventDefault();
    var form = document.getElementById('cart') || event.target;

    showModal(function() {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout';
      input.value = '';
      form.appendChild(input);
      form.submit();
    });
  }

  function setupCheckoutIntercept() {
    document.querySelectorAll('#cart, #CartDrawer form').forEach(function(form) {
      form.removeEventListener('submit', interceptCheckoutSubmit);
      form.addEventListener('submit', interceptCheckoutSubmit);
    });
  }

  function addBadge(item) {
    if (!item || item.querySelector('.preorder-item-badge')) return;
    var titleLink = item.querySelector('.horizontal-product__title') || item.querySelector('.cart__item-title');
    if (titleLink) {
      var badge = document.createElement('span');
      badge.className = 'preorder-item-badge';
      badge.textContent = 'Preventa';
      titleLink.parentNode.insertBefore(badge, titleLink.nextSibling);
    }
  }

  function injectBanner() {
    if (document.querySelector('.preorder-notice-banner')) return;
    var bannerHTML =
      '<div class="preorder-notice-banner">' +
        '<svg class="preorder-notice-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<circle cx="12" cy="12" r="10"/>' +
          '<line x1="12" y1="8" x2="12" y2="12"/>' +
          '<line x1="12" y1="16" x2="12.01" y2="16"/>' +
        '</svg>' +
        '<div class="preorder-notice-content">' +
          '<p class="preorder-notice-title">Preventa</p>' +
          '<p>Los siguientes productos están en preventa. Tu pedido se enviará cuando todos los productos estén disponibles. Revisa la fecha estimada en la descripción de cada producto. Si no deseas esperar, realiza un pedido por separado.</p>' +
        '</div>' +
      '</div>';
    var target = document.querySelector('#MainCart .cart__form') || document.querySelector('#CartDrawer cart-items');
    if (target && target.parentNode && !target.parentNode.querySelector('.preorder-notice-banner')) {
      target.insertAdjacentHTML('beforebegin', bannerHTML);
    }
  }

  function setupCloseHandler() {
    var closeBtn = document.getElementById('custom-preorder-close');
    var overlay = document.getElementById('custom-preorder-overlay');
    var confirmBtn = document.getElementById('custom-preorder-confirm');
    if (closeBtn) closeBtn.addEventListener('click', hideModal);
    if (overlay) overlay.addEventListener('click', function(e) { if (e.target === overlay) hideModal(); });
    if (confirmBtn) confirmBtn.addEventListener('click', confirmCheckout);
  }

  function handlePreorder() {
    if (!hasPreorderItems()) return;
    var data = getPreorderData();
    data.items.forEach(function(item) {
      var el = document.querySelector('#CartDrawer [data-handle="' + item.handle + '"]');
      if (!el) {
        var items = document.querySelectorAll('#MainCart .cart-item');
        for (var i = 0; i < items.length; i++) {
          var link = items[i].querySelector('.cart__item-title');
          if (link && link.getAttribute('href') && link.getAttribute('href').indexOf('/products/' + item.handle) !== -1) {
            el = items[i]; break;
          }
        }
      }
      addBadge(el);
    });
    injectBanner();
    setupCheckoutIntercept();
  }

  document.addEventListener('DOMContentLoaded', function() {
    setupCloseHandler();
    setTimeout(handlePreorder, 500);
  });

  document.addEventListener('cart:updated', function() {
    setTimeout(handlePreorder, 300);
  });
})();